var React = require('react');

function SmallArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"3"},React.createElement("polyline",{"points":"1 1 9 9 17 1"})));
}

SmallArrowDown.defaultProps = {"width":"18px","height":"11px","viewBox":"0 0 18 11","version":"1.1"};

module.exports = SmallArrowDown;

SmallArrowDown.default = SmallArrowDown;
